import * as React from "react";

const Info: React.FC = () => {
    return <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-500.000000, -413.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(421.000000, 183.000000)">
                    <path d="M12,2 C17.5,2 22,6.5 22,12 C22,17.5 17.5,22 12,22 C6.5,22 2,17.5 2,12 C2,6.5 6.5,2 12,2 L12,2 Z M12,0 C5.4,0 0,5.4 0,12 C0,18.6 5.4,24 12,24 C18.6,24 24,18.6 24,12 C24,5.4 18.6,0 12,0 L12,0 L12,0 Z"></path>
                    <path d="M12,8.276 C12.612,8.276 13.054,7.851 13.054,7.273 C13.054,6.695 12.612,6.27 12,6.27 C11.371,6.27 10.929,6.695 10.929,7.273 C10.929,7.851 11.371,8.276 12,8.276 Z M12.816,18 L12.816,9.925 L11.184,9.925 L11.184,18 L12.816,18 Z" fillRule="nonzero"></path>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Info);
